import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../helpers/reducerRegistry'
import { PERIOD_TYPE } from '../constant'
import { getHighlight } from './thunk'

const initialState = {
  typePeriod: PERIOD_TYPE.YEARLY,
  loading: {
    getHighlight: true,
  },
  getHightLightData: {
    totalTradeCreditLimit: undefined,
    riskScore: null,
    prevRiskScore: null,
    riskScoreColor: '',
    modelSegmentName: '',
    yearReportCal: '',
  },
}
const slice = createSlice({
  name: 'score/highLight',
  initialState: initialState,
  reducers: {
    changePeriodType(state, action) {
      state.typePeriod = action.payload
    },
  },
  extraReducers: (builder) => {
    //get Hightlight
    builder.addCase(getHighlight.pending, (state, action) => {
      state.loading.getHighlight = true
    })
    builder.addCase(getHighlight.fulfilled, (state, action) => {
      state.getHightLightData = action.payload
        ? action.payload
        : initialState['getHightLightData']
      state.loading.getHighlight = false
    })
    builder.addCase(getHighlight.rejected, (state, action) => {
      state.loading.getHighlight = action.payload.loading
    })
  },
})

export const selectTypePeriod = (state) => state[slice.name].typePeriod

//get HightLight
export const getHighlightScore = (type) => (state) =>
  type
    ? state[slice.name]?.getHightLightData[type]
    : state[slice.name]?.getHightLightData

export const selectLoadingHightLight = (state) =>
  state[slice.name].loading.getHighlight

export const { changePeriodType } = slice.actions

register(slice.name, slice.reducer)
